import axiosConfig from '../axiosConfig';
import {
	ChatRequest,
	ChatResponse,
	GenericResponse,
	InovationChatRequest,
	InovationChatResponse,
} from '../types';

export class ChatActions {
	public static SendMessage(request: ChatRequest): Promise<GenericResponse<ChatResponse>> {
		const url = 'app/ai/chat';

		return axiosConfig.instance.post(url, request).then((res) => {
			return res.data as GenericResponse<ChatResponse>;
		});
	}

	/**
	 * Sends a message to the Innovation AI endpoint (used by Advanced AI page).
	 * Base URL is constructed from env vars:
	 *  - REACT_APP_INNOVATION_AI_API_ID
	 *  - REACT_APP_INNOVATION_AI_ENVIRONMENT
	 * Falls back to the hardcoded URL if env vars are missing.
	 */
	public static sendInovationAIMessage(
		request: InovationChatRequest
	): Promise<InovationChatResponse> {
		const apiId = process.env.REACT_APP_INNOVATION_AI_API_ID;
		const environment = process.env.REACT_APP_INNOVATION_AI_ENVIRONMENT;
		const fallback = 'https://ygqpos4pjd.execute-api.us-east-1.amazonaws.com/dev/chat';
		const API_KEY = 'c2051712053c930e9345e66e24a58de140f33e8be8ba6c01b242358774ef4f81';

		const url =
			apiId && environment
				? `https://${apiId}.execute-api.us-east-1.amazonaws.com/${environment}/chat`
				: fallback;

		return axiosConfig.instance
			.post(url, request, {
				headers: {
					'x-api-key': API_KEY,
				},
			})
			.then((res) => res.data as InovationChatResponse);
	}
}
